<template>
  <router-link v-if="href!==undefined&&!isLink(href)&&!click"
               :class="{point}" :to="href">
    {{ name }}
  </router-link>
  <a v-else-if="href!==undefined&&isLink(href)&&!click" target="_blank"
     :class="{point}" :href="href">
    {{ name }}
  </a>
  <a v-else-if="href===undefined&&click"
     :class="{point}" @click="click(href)">
    {{ name }}
  </a>
  <a v-else
     :class="{point}">
    {{ name }}
  </a>
</template>

<script lang="ts" type="text/tsx">
export default {
  name: 'page_link',
  props: [
    'name',
    'point',
    'href',
    'click',
    'icon'
  ],
  methods: {
    /**
     * 判断是否是外链
     * @param {string} url 链接
     * @return {boolean} 是否是外链
     */
    isLink(url: string): boolean {
      return (url.indexOf('http://') > -1 || url.indexOf('https://') > -1);
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';
</style>